export default __webpack_public_path__ + "static/Statistics 2-562eaacbfba02c5d9db7e569284163d5.svg";